import {CONFIG} from "../../config";
import axios from "axios";

async function GetDeviceCoresQuery(deviceId, coreId) {
    const location = CONFIG.API_URL + "device_configuration/get/" + deviceId + "/" + coreId;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetDeviceCoresQuery;